import { Interview } from '../../../../../entities/Interview';
import { EmptyTab } from '../../../../../components/EmptyTab';
import UndrawLost from '../../../../../images/undraw_empty_state.svg';
import React from 'react';
import { ScorecardAttributeSummary } from '../../../../../entities/ScorecardAttributeSummary';
import { ElementPanel } from '../../../../../components/ElementPanel';
import { SummaryPanel } from '../../../../../components/SummaryPanel';
import classNames from 'classnames';
import styles from './styles.module.scss';

interface PropTypes {
  interview: Interview;
}

function AttributeSummary(props: { attribute: ScorecardAttributeSummary }) {
  if (!props.attribute.summary) return null;

  return (
    <ElementPanel
      element={
        <SummaryPanel summary={props.attribute.summary} classNames={''} />
      }
      title={props.attribute.title}
      classNames={'bg-white border-0 rounded-0 p-0'}
      titleClasses={'fs-5 fw-bold'}
    />
  );
}

export function AttributeNotes(props: PropTypes) {
  if (
    props.interview.scorecard_attribute_summaries == null ||
    props.interview.scorecard_attribute_summaries.filter((s) => s.summary)
      .length === 0
  ) {
    return (
      <EmptyTab
        title='No attribute summaries available yet'
        text='We are processing attribute summaries. Please check back later.'
        imageSrc={UndrawLost}
        size='medium'
      />
    );
  }
  return (
    <div
      className={classNames(
        'd-flex',
        'flex-column',
        'gap-3',
        'mt-2',
        styles.expandableNotes,
      )}
    >
      {props.interview.scorecard_attribute_summaries.map(
        (attribute: ScorecardAttributeSummary, index: number) => (
          <AttributeSummary key={index} attribute={attribute} />
        ),
      )}
    </div>
  );
}
